import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { createDecorator as createServiceDecorator } from '../../instantiation/common/instantiation.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { Emitter } from '../../../base/common/event.js';
export var ILogService = createServiceDecorator('logService');
export var LogLevel;

(function (LogLevel) {
  LogLevel[LogLevel["Trace"] = 0] = "Trace";
  LogLevel[LogLevel["Debug"] = 1] = "Debug";
  LogLevel[LogLevel["Info"] = 2] = "Info";
  LogLevel[LogLevel["Warning"] = 3] = "Warning";
  LogLevel[LogLevel["Error"] = 4] = "Error";
  LogLevel[LogLevel["Critical"] = 5] = "Critical";
  LogLevel[LogLevel["Off"] = 6] = "Off";
})(LogLevel || (LogLevel = {}));

export var DEFAULT_LOG_LEVEL = LogLevel.Info;
export var AbstractLogService = /*#__PURE__*/function (_Disposable) {
  _inherits(AbstractLogService, _Disposable);

  var _super = _createSuper(AbstractLogService);

  function AbstractLogService() {
    var _this;

    _classCallCheck(this, AbstractLogService);

    _this = _super.apply(this, arguments);
    _this.level = DEFAULT_LOG_LEVEL;
    _this._onDidChangeLogLevel = _this._register(new Emitter());
    return _this;
  }

  _createClass(AbstractLogService, [{
    key: "setLevel",
    value: function setLevel(level) {
      if (this.level !== level) {
        this.level = level;

        this._onDidChangeLogLevel.fire(this.level);
      }
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      return this.level;
    }
  }]);

  return AbstractLogService;
}(Disposable);
export var ConsoleLogService = /*#__PURE__*/function (_AbstractLogService) {
  _inherits(ConsoleLogService, _AbstractLogService);

  var _super2 = _createSuper(ConsoleLogService);

  function ConsoleLogService() {
    var _this2;

    var logLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_LOG_LEVEL;

    _classCallCheck(this, ConsoleLogService);

    _this2 = _super2.call(this);

    _this2.setLevel(logLevel);

    return _this2;
  }

  _createClass(ConsoleLogService, [{
    key: "trace",
    value: function trace(message) {
      if (this.getLevel() <= LogLevel.Trace) {
        var _console;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        (_console = console).log.apply(_console, ['%cTRACE', 'color: #888', message].concat(args));
      }
    }
  }, {
    key: "info",
    value: function info(message) {
      if (this.getLevel() <= LogLevel.Info) {
        var _console2;

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        (_console2 = console).log.apply(_console2, ['%c INFO', 'color: #33f', message].concat(args));
      }
    }
  }, {
    key: "error",
    value: function error(message) {
      if (this.getLevel() <= LogLevel.Error) {
        var _console3;

        for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        (_console3 = console).log.apply(_console3, ['%c  ERR', 'color: #f33', message].concat(args));
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {// noop
    }
  }]);

  return ConsoleLogService;
}(AbstractLogService);